import styled from 'styled-components'

const ResponsiveSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0 0;
  margin: 20px auto;
  max-width: ${props => props.theme.metrics.contentMaxWidth}px;
  @media (min-width: ${props => props.theme.metrics.tablet}px) {
    margin: 60px auto;
    flex-direction: row;
  }
`
const TextContainer = styled.div`
  flex: 1;
  padding: 0 30px;
`

const Subhead = styled.h3`
  font-size: 2em;
  margin-bottom: 10px;
`

const SavingsTableHead = styled.h3`
  font-weight: 800;
  font-size: 18px;
  line-height: 22px;
  text-align: center;
`

const BodyText = styled.p`
  font-size: 1.2em;
  line-height: 1.6em;
  margin-bottom: 20px;
`

const SavingsTableContainer = styled.div`
  flex: 1;
  padding: 10px;
  border-radius: 12px;
  @media (min-width: ${props => props.theme.metrics.tablet}px) {
    padding-left: 20px;
  }
`

const SavingsTable = styled.table`
  width: 100%;
  table-layout: fixed;
  border-collapse: collapse; // Change this line
  border-spacing: 0;
  margin-right: 0px;
  margin-left: 0px;
  margin-bottom: 0px;
  overflow: hidden;

  thead {
    background-color: #002244;
    tr:first-child th:first-child {
      border-top-left-radius: 12px;
    }
    tr:first-child th:last-child {
      border-top-right-radius: 12px;
    }
  }

  thead tr th,
  tbody tr td {
    border: none;
    padding: 18px;
  }

  thead tr th {
    color: #ffffff;
    font-weight: 800;
    font-size: 16px;
    line-height: 18px;
    text-align: center;
  }
  tbody {
    background-color: #ffffff;
    tr:last-of-type td:first-of-type {
      border-bottom-left-radius: 12px;
    }
    tr:last-of-type td:last-of-type {
      border-bottom-right-radius: 12px;
    }
    tr td {
      border: 1px solid hsla(0, 0%, 50.2%, 0.5019607843);
    }
  }

  tr:nth-child(even) {
    background-color: #f3f3f3;
  }
`

const SmartSavingsSection = () => (
  <ResponsiveSection>
    <TextContainer>
      <Subhead>Smart Savings for Savvy Buyers</Subhead>
      <BodyText>
        Access everything you need to purchase your next property while receiving a significant
        portion of your agent’s commission back at closing. Whether you’re downsizing for retirement
        or expanding your investment portfolio, find out how much you could save with HomeLister’s
        commission-sharing program. Our buyers have received <strong>over $20,000 back</strong> at
        closing, with exact amounts varying by state and purchase price*.
      </BodyText>
    </TextContainer>
    <SavingsTableContainer>
      <SavingsTableHead>
        Ex: Rebate for $500,000 purchase used for downpayment assistance.
      </SavingsTableHead>
      <SavingsTable>
        <thead>
          <tr>
            <th> </th>
            <th>HomeLister Buyer Network</th>
            <th>Tradtional Agent</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Offer</td>
            <td>$500,000</td>
            <td>$500,000</td>
          </tr>
          <tr>
            <td>Commission</td>
            <td>2.5%</td>
            <td>2.5%</td>
          </tr>
          <tr>
            <td>Rebate*</td>
            <td>
              <strong>$5,000-$12,500</strong>
            </td>
            <td>$0</td>
          </tr>
          <tr>
            <td>Down Payment (10%)</td>
            <td>
              <strong>$37,500</strong>
            </td>
            <td>$50,000</td>
          </tr>
          <tr>
            <td>Results</td>
            <td>
              <strong>WIN</strong>
            </td>
            <td>Sorry</td>
          </tr>
        </tbody>
      </SavingsTable>
    </SavingsTableContainer>
  </ResponsiveSection>
)

export default SmartSavingsSection
